export default __webpack_public_path__ + "static/media/ICON_logo.c1d83ab5.png";